import {
  ReviewSmallIcon
} from "..";
import styles from "./styles.module.css";

export const RightColumn = ({
  children,
  withBg,
  withHeading,
  headingText
}) => {

  return (
    <div className={styles.rightColumn}>
      {withHeading && (
        <div className={styles.rightColumnHeading}>  
        </div>
      )}
      <div
        className={withBg ? styles.rightColumnBg : styles.rightColumnWithoutBg}
      >
        {children}
      </div>
    </div>
  );
};
